/* Torflux 2.0 — interactions for the tf-* sections */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Horizon makes .page-wrapper the scroll container at >=990px (html/body are
     overflow:hidden), and the window scrolls below that. Support both. */
  var pageWrapper = document.querySelector('.page-wrapper');
  function wrapperScrolls() {
    return !!pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight + 1 &&
      /(auto|scroll)/.test(getComputedStyle(pageWrapper).overflowY);
  }
  function scrollTopNow() {
    return Math.max(window.scrollY || 0, pageWrapper ? pageWrapper.scrollTop : 0);
  }
  function scrollMax() {
    if (wrapperScrolls()) return pageWrapper.scrollHeight - pageWrapper.clientHeight;
    return document.documentElement.scrollHeight - window.innerHeight;
  }
  function onAnyScroll(fn) {
    // capture: element scroll events don't bubble, but they do reach document in the capture phase
    document.addEventListener('scroll', fn, { passive: true, capture: true });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-tf-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var el = e.target;
            el.classList.add('is-in');
            io.unobserve(el);
            // Drop the stagger delay once revealed so hover/tilt feels instant
            var i = parseFloat(getComputedStyle(el).getPropertyValue('--i')) || 0;
            setTimeout(function () { el.classList.add('tf-done'); }, 1000 + i * 70);
          }
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Count-up numbers ---------- */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-tf-count]:not([data-tf-counted])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-tf-counted', '');
      var target = parseFloat(el.getAttribute('data-tf-count')) || 0;
      var suffix = el.getAttribute('data-tf-suffix') || '';
      if (reduced) { el.textContent = target.toLocaleString() + suffix; return; }
      var start = performance.now();
      var dur = 1600;
      (function tick(now) {
        var t = Math.min(1, (now - start) / dur);
        var eased = 1 - Math.pow(1 - t, 4);
        el.textContent = Math.round(target * eased).toLocaleString() + suffix;
        if (t < 1) requestAnimationFrame(tick);
      })(start);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3D tilt + cursor spotlight on cards ---------- */
  function initTilt(root) {
    if (!finePointer || reduced) return;
    (root || document).querySelectorAll('[data-tf-tilt]:not([data-tf-tilt-ready])').forEach(function (el) {
      el.setAttribute('data-tf-tilt-ready', '');
      var max = parseFloat(el.getAttribute('data-tf-tilt')) || 8;
      var raf = null;
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width;
        var y = (ev.clientY - r.top) / r.height;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.setProperty('--rx', ((0.5 - y) * max).toFixed(2) + 'deg');
          el.style.setProperty('--ry', ((x - 0.5) * max).toFixed(2) + 'deg');
          el.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          el.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        });
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Magnetic buttons ---------- */
  function initMagnetic(root) {
    if (!finePointer || reduced) return;
    (root || document).querySelectorAll('[data-tf-magnetic]:not([data-tf-mag-ready])').forEach(function (el) {
      el.setAttribute('data-tf-mag-ready', '');
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var dx = ev.clientX - (r.left + r.width / 2);
        var dy = ev.clientY - (r.top + r.height / 2);
        el.style.transform = 'translate(' + dx * 0.18 + 'px,' + dy * 0.28 + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Scroll-driven: progress bar, back-to-top, parallax ---------- */
  var progress = document.getElementById('tf-progress');
  var topBtn = document.getElementById('tf-top');
  var parallax = [];
  function collectParallax() {
    // Parallax only on mouse/trackpad devices; on phones it just costs scroll performance
    parallax = reduced || !finePointer ? [] : Array.prototype.slice.call(document.querySelectorAll('[data-tf-parallax]'));
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = scrollTopNow();
      var max = scrollMax();
      var p = max > 0 ? Math.min(1, y / max) : 0;
      if (progress) progress.style.setProperty('--p', p.toFixed(4));
      if (topBtn) {
        topBtn.style.setProperty('--p', p.toFixed(4));
        topBtn.classList.toggle('is-on', y > window.innerHeight * 0.8);
      }
      for (var i = 0; i < parallax.length; i++) {
        var el = parallax[i];
        var f = parseFloat(el.getAttribute('data-tf-parallax')) || 0.2;
        el.style.transform = 'translate3d(0,' + (y * f).toFixed(1) + 'px,0)';
      }
      ticking = false;
    });
  }
  if (topBtn) {
    topBtn.addEventListener('click', function () {
      var opts = { top: 0, behavior: reduced ? 'auto' : 'smooth' };
      window.scrollTo(opts);
      if (pageWrapper) pageWrapper.scrollTo(opts);
    });
  }

  /* ---------- Sticky quick-nav scroll-spy ---------- */
  function initSpy(root) {
    (root || document).querySelectorAll('[data-tf-spy]:not([data-tf-spy-ready])').forEach(function (nav) {
      nav.setAttribute('data-tf-spy-ready', '');
      var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
      var map = links
        .map(function (a) {
          var t = document.getElementById(a.getAttribute('href').slice(1));
          return t ? { a: a, t: t } : null;
        })
        .filter(Boolean);
      var track = nav.querySelector('.tf-qnav__track');
      function setActive(a) {
        links.forEach(function (l) { l.classList.toggle('is-active', l === a); });
        if (a && track) {
          var pill = nav.querySelector('.tf-qnav__pill');
          if (pill) {
            pill.style.width = a.offsetWidth + 'px';
            pill.style.transform = 'translateX(' + a.offsetLeft + 'px)';
            pill.style.opacity = '1';
          }
          var left = a.offsetLeft - track.clientWidth / 2 + a.offsetWidth / 2;
          track.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
        } else {
          var p2 = nav.querySelector('.tf-qnav__pill');
          if (p2) p2.style.opacity = '0';
        }
      }
      function spy() {
        var line = window.innerHeight * 0.35;
        // Active = the section whose top most recently passed the line (DOM order, not menu order)
        var current = null;
        var best = -Infinity;
        map.forEach(function (m) {
          var top = m.t.getBoundingClientRect().top - line;
          if (top <= 0 && top > best) { best = top; current = m.a; }
        });
        setActive(current);
        nav.classList.toggle('is-stuck', nav.getBoundingClientRect().top <= 1);
      }
      onAnyScroll(function () { requestAnimationFrame(spy); });
      window.addEventListener('resize', spy);
      spy();
    });
  }

  /* ---------- Marquee: duplicate content for a seamless loop ---------- */
  function initMarquee(root) {
    (root || document).querySelectorAll('[data-tf-marquee]:not([data-tf-mq-ready])').forEach(function (row) {
      row.setAttribute('data-tf-mq-ready', '');
      var inner = row.querySelector('.tf-mq__inner');
      if (!inner) return;
      var clone = inner.innerHTML;
      inner.innerHTML = clone + clone;
      inner.querySelectorAll('a').forEach(function (a, i, all) {
        if (i >= all.length / 2) { a.setAttribute('tabindex', '-1'); a.setAttribute('aria-hidden', 'true'); }
      });
    });
  }

  /* ---------- Typewriter (promo code ticket) ---------- */
  function initType(root) {
    (root || document).querySelectorAll('[data-tf-type]:not([data-tf-type-ready])').forEach(function (el) {
      el.setAttribute('data-tf-type-ready', '');
      var words = (el.getAttribute('data-tf-type') || '').split('|').filter(Boolean);
      if (!words.length) return;
      if (reduced) { el.textContent = words[0]; return; }
      var w = 0, c = 0, del = false;
      (function loop() {
        var word = words[w];
        el.textContent = word.slice(0, c);
        if (!del && c < word.length) { c++; setTimeout(loop, 95); }
        else if (!del) { del = true; setTimeout(loop, 1700); }
        else if (c > 0) { c--; setTimeout(loop, 45); }
        else { del = false; w = (w + 1) % words.length; setTimeout(loop, 300); }
      })();
    });
  }

  /* ---------- Product cards everywhere: scroll reveal + tilt ---------- */
  function initCards(root) {
    var cards = (root || document).querySelectorAll('product-card:not([data-tf-card])');
    if (!cards.length) return false;
    cards.forEach(function (card) {
      card.setAttribute('data-tf-card', '');
      if (card.closest('header-component, dialog, .cart-drawer, predictive-search-component')) return;
      card.setAttribute('data-tf-tilt', '5');
      var host = card.parentElement;
      if (!host || host.hasAttribute('data-tf-reveal') || host.matches('.product-grid, .resource-list')) return;
      var idx = Array.prototype.indexOf.call(host.parentElement ? host.parentElement.children : [], host);
      host.setAttribute('data-tf-reveal', '');
      host.style.setProperty('--i', Math.max(0, idx) % 4);
    });
    return true;
  }

  /* ---------- Pause animations in sections that are off screen ---------- */
  var pauseIO = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('tf-paused', !e.isIntersecting); });
      }, { rootMargin: '200px 0px' })
    : null;
  function initPause(root) {
    if (!pauseIO) return;
    (root || document).querySelectorAll('.shopify-section:not([data-tf-pause])').forEach(function (sec) {
      if (!sec.querySelector('.tf-hero, .tf-ch, .tf-ph, .tf-mq, .tf-cg, .tf-why, .tf-earn, .tf-qnav')) return;
      sec.setAttribute('data-tf-pause', '');
      pauseIO.observe(sec);
    });
  }

  function initAll(root) {
    initPause(root);
    initCards(root);
    initReveal(root);
    initCounters(root);
    initTilt(root);
    initMagnetic(root);
    initSpy(root);
    initMarquee(root);
    initType(root);
    collectParallax();
    onScroll();
  }

  onAnyScroll(onScroll);
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* New product cards (infinite scroll, filters, recommendations) */
  if ('MutationObserver' in window) {
    var mqQueued = false;
    new MutationObserver(function () {
      if (mqQueued) return;
      mqQueued = true;
      requestAnimationFrame(function () {
        mqQueued = false;
        if (document.querySelector('product-card:not([data-tf-card])')) initAll(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Re-run when sections are re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.Torflux2 = { init: initAll, scrollTop: scrollTopNow };
})();
